import React from "react"
import { useProductManager } from "../../hooks/products/useProductManager"

export default function ProductManager() {
  const {
    form,
    list,
    loading,
    showForm,
    setShowForm,
    msg,
    onChange,
    onSubmit,
  } = useProductManager()

  return (
    <div className="grid md:grid-cols-2 gap-6">
      <div>
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-xl font-bold">Cargar producto</h2>
          <button
            className="text-sm underline"
            onClick={() => setShowForm((v) => !v)}
          >
            {showForm ? "Cerrar" : "Abrir"}
          </button>
        </div>
        {showForm && (
          <form
            onSubmit={onSubmit}
            className="bg-white border rounded-xl p-4 space-y-3"
          >
            <input
              className="border rounded p-2 w-full"
              name="name"
              placeholder="Nombre"
              value={form.name}
              onChange={onChange}
              required
            />
            <input
              className="border rounded p-2 w-full"
              name="category"
              placeholder="Categoría"
              value={form.category}
              onChange={onChange}
              required
            />
            <input
              className="border rounded p-2 w-full"
              name="price"
              placeholder="Precio"
              value={form.price}
              onChange={onChange}
              type="number"
              step="0.01"
            />
            <textarea
              className="border rounded p-2 w-full"
              name="description"
              placeholder="Descripción"
              value={form.description}
              onChange={onChange}
              rows={3}
            />
            <input
              className="border rounded p-2 w-full"
              name="address"
              placeholder="Dirección"
              value={form.address}
              onChange={onChange}
            />
            <div className="grid grid-cols-2 gap-2">
              <input
                className="border rounded p-2 w-full"
                name="geo_lat"
                placeholder="Latitud"
                value={form.geo_lat}
                onChange={onChange}
              />
              <input
                className="border rounded p-2 w-full"
                name="geo_lng"
                placeholder="Longitud"
                value={form.geo_lng}
                onChange={onChange}
              />
            </div>
            <input
              className="border rounded p-2 w-full"
              type="file"
              accept="image/*"
              onChange={onChange}
            />
            <button
              disabled={loading}
              className="px-4 py-2 rounded bg-black text-white"
            >
              {loading ? "Guardando…" : "Guardar"}
            </button>
            {msg && <div className="text-sm pt-2">{msg}</div>}
          </form>
        )}
      </div>
      <div>
        <h2 className="text-xl font-bold mb-2">Mis productos</h2>
        <div className="grid sm:grid-cols-2 gap-3">
          {list.map((p) => (
            <div key={p.id} className="border rounded-xl p-3">
              <div className="font-semibold">{p.name}</div>
              <div className="text-sm text-gray-600">{p.category}</div>
              <div className="text-sm">${p.price}</div>
            </div>
          ))}
          {!list.length && (
            <div className="text-sm text-gray-500">No hay productos aún.</div>
          )}
        </div>
      </div>
    </div>
  )
}
